import React, { useState, useEffect, useRef } from 'react';
import _ from 'lodash';
import cx from 'classnames';

import { BackgroundView } from '../../background';
import { Widget, WidgetsContext } from '../../core';
import Portal from '../../../../components/Portal';


import styles from './filter.module.scss';
import { CONTENT_FILTER_CONTAINER, CONTENT_SEARCH } from '../../../../constants/widgetTypes';
import { PageContext } from '../../page';
import { useLiveElementSelector, useWidgetChildrenSelector, useWidgetSelector } from '../../core/hooks';

const FilterWidgetComponent = ({ className, style, widgetProps, breakpoint, children, ...rest }) => {

  const [scrollAnimation, setScrollAnimation] = useState({
    initiate: false,
    animate: false,
  });

  const [filterOffset, setFilterOffset] = useState(0);

  const { zoom, pageWidth = '100%' } = React.useContext(PageContext);
  const filterListenerRef = useRef();

  const id = _.get(widgetProps, 'uid');
  const parentId = _.get(widgetProps, 'parent');
  const parentWidgetProps = useWidgetSelector(parentId);
  const showFilters = _.get(parentWidgetProps, 'properties.desktop.filters');
  const showSearch = _.get(parentWidgetProps, 'properties.desktop.search');
  const type = _.get(widgetProps, 'type');

  const deviceLayout = _.get(widgetProps, `properties.${breakpoint}.layout`);
  const background = _.get(widgetProps, 'properties.desktop.background');
  const scrollEffect = _.get(widgetProps, 'properties.desktop.scrollEffect');
  const alignment = getContainerAlignment(widgetProps, breakpoint);
  const buttonAlignmnet = getDropDownAlignment(widgetProps, breakpoint);
  const parentProps = useWidgetSelector(parentId);
  const stretched = _.get(parentProps, `properties.desktop.stretched`);
  const widgetChildren = useWidgetChildrenSelector(id);

  let prevScrollpos = 0;
  var widgetStyle = {
    ...style,
    ...getStyles(widgetProps, stretched, breakpoint, pageWidth),
    // ...getscrollEffect(scrollEffect, filterOffset, style, scrollAnimation, zoom, breakpoint)
  }

  useEffect(() => {
    // clean up code
    // window.addEventListener('scroll', handleOnScroll);
    // return () => window.removeEventListener('scroll', handleOnScroll);
  }, [deviceLayout]);

  const handleOnScroll = () => {

    if (scrollEffect === 'NONE') {
      return;
    }

    var scrollTopOffset = filterListenerRef.current.getBoundingClientRect().top;

    switch (scrollEffect) {
      case 'STICKY':
        setScrollAnimation({
          ...scrollAnimation,
          initiate: (window.pageYOffset >= scrollTopOffset) && scrollTopOffset < 0
        })
        break;

      case 'SLIDE':
      case 'FADE':
        var currentScrollPos = window.pageYOffset;
        setScrollAnimation({
          initiate: scrollTopOffset < 0,
          animate: (prevScrollpos > currentScrollPos) && scrollTopOffset < 0
        })
        prevScrollpos = currentScrollPos;
        break;

      case 'BACKGROUND_SLIDE':
      case 'BACKGROUND_FADE':
        var currentScrollPos = window.pageYOffset;
        setScrollAnimation({
          ...scrollAnimation,
          initiate: (window.pageYOffset >= scrollTopOffset) && scrollTopOffset < 0,
          animate: scrollTopOffset < 0
        })

        prevScrollpos = currentScrollPos;
        break;

      default:
        setScrollAnimation(false);
        break;
    }

  };

  return (
    <div id={id}
      className={cx(className, styles.filters,
        //  styles[scrollEffect.toLowerCase()],
        {
        })}
      style={widgetStyle}
      data-widget-id={id}
      data-widget-type={type}
    >
      <BackgroundView
        background={background}
        breakpoint={breakpoint}
      // className={scrollAnimation.animate ? styles[`${scrollEffect.toLowerCase()}_show`] : styles[`${scrollEffect.toLowerCase()}_hide`]}
      />
      <div style={alignment} className={cx(styles.childContainer)}>
        {
          React.Children.map(children, (child, index) => {
            const childType = _.get(child, 'props.widgetProps.type');
            if (childType == CONTENT_FILTER_CONTAINER && showFilters) {
              return React.cloneElement(child, {
                key: index,
                parentProps: widgetProps,
                alignment: buttonAlignmnet
              });
            }

            if (childType == CONTENT_SEARCH && showSearch) {
              return React.cloneElement(child, {
                key: index,
                parentProps: widgetProps,
              });
            }
          })
        }
      </div>
    </div>
  );
};

function getStyles(widgetProps, stretched, breakpoint, pageWidth) {

  const margin = _.get(widgetProps, 'properties.desktop.margin', 0);
  const padding = _.get(widgetProps, `properties.${breakpoint}.padding`, 0);

  var widgetStyles = {
    paddingTop: `${padding}px`,
    paddingBottom: `${padding}px`,
    transformOrigin: 'top',
    marginLeft: `calc((100% - ${pageWidth}px) * 0.5)`
  }

  if (breakpoint === 'desktop') {
    widgetStyles = {
      ...widgetStyles,
      width: `1200px`,
      paddingLeft: `${padding}px`,
      paddingRight: `${padding}px`
    }
  }

  if (stretched) {
    widgetStyles = {
      ...widgetStyles,
      marginLeft: '0px',
      width: `calc(100% - 2 * ${margin}px)`,
      left: `calc((100% - 2 * ${margin}px))/2)`
    }
  }

  if (breakpoint === 'mobile') {
    widgetStyles = {
      ...widgetStyles,
      width: pageWidth,
    }
  }

  return widgetStyles;
}

// function getscrollEffect(scrollEffect, filterOffset, style, scrollAnimation, zoom, breakpoint) {

//   const { initiate, animate } = scrollAnimation;
//   var styles = scrollEffect === 'NONE' ? {} : { transform: `translate(0px, ${filterOffset}px) rotate(0deg) scale(${zoom})` };

//   if (!initiate) {
//     return styles;
//   }

//   switch (scrollEffect) {

//     case 'STICKY': {
//       return {
//         ...styles,
//         position: 'fixed',
//         top: `0px`,
//         zIndex: 900,
//         transform: `scale(${zoom})`,
//       }
//     }

//     case 'SLIDE': {
//       return {
//         ...styles,
//         position: 'fixed',
//         top: animate ? '0px' : `-${style.height}`,
//         zIndex: 900,
//         transform: `scale(${zoom})`,
//       }
//     }
//   }

//   return styles;

// }

function getContainerAlignment(widgetProps, breakpoint) {
  const alignment = _.get(widgetProps, `properties.${breakpoint}.alignment`, {
    position: 'center',
    margin: 0
  });
  const horizontalColumn = _.get(widgetProps, `properties.${breakpoint}.horizontalColumn`, false);
  const columnReverse = _.get(widgetProps, `properties.${breakpoint}.columnReverse`, false);
  const spacing = _.get(widgetProps, `properties.${breakpoint}.spacing`, 16);


  const verticalAlignment = _.get(widgetProps, `properties.${breakpoint}.verticalAlignment`, {
    position: 'center',
    margin: 0
  });

  var position = _.get(alignment, 'position', 'center');
  var margin = _.get(alignment, 'margin', 0);

  var verticalPosition = _.get(verticalAlignment, 'position', 'center');
  var verticalMargin = _.get(verticalAlignment, 'margin', 0);

  var containerStyles = {}

  //verticalAlignment
  containerStyles['alignItems'] = position;

  if (position === 'left') {
    containerStyles = {
      ...containerStyles,
      alignItems: 'flex-start',
      paddingLeft: breakpoint == 'mobile' ? '0px' : `${margin}px`
    }
  } else if (position === 'right') {
    containerStyles = {
      ...containerStyles,
      alignItems: 'flex-end',
      paddingRight: breakpoint == 'mobile' ? '0px' : `${margin}px`
    }
  }

  //alignment
  containerStyles['justifyContent'] = verticalPosition;

  if (verticalPosition === 'top') {
    containerStyles = {
      ...containerStyles,
      justifyContent: 'flex-start',
      paddingTop: `${verticalMargin}px`
    }
  }
  else if (verticalPosition === 'bottom') {
    containerStyles = {
      ...containerStyles,
      justifyContent: 'flex-end',
      paddingBottom: `${verticalMargin}px`
    }
  }

  //spacing between items
  if (spacing && !horizontalColumn) {
    containerStyles = {
      ...containerStyles,
      rowGap: `${spacing}px`
    }
  }

  if (breakpoint == 'mobile') {
    containerStyles = {
      ...containerStyles,
      flexDirection: columnReverse ? 'column-reverse' : 'column',
    }
    return containerStyles;
  }

  //horizontalLayout
  containerStyles['flexDirection'] = 'column';
  if (horizontalColumn && breakpoint == 'desktop') {
    containerStyles = {
      ...containerStyles,
      flexDirection: 'row',
      justifyContent: 'space-between',
      paddingLeft: '0px',
      paddingRight: '0px'
    }
  }

  //reverse direction
  if (columnReverse) {
    containerStyles = {
      ...containerStyles,
      flexDirection: horizontalColumn ? 'row-reverse' : 'column-reverse'
    }
  }

  return containerStyles;
}


function getDropDownAlignment(widgetProps, breakpoint) {
  const alignment = _.get(widgetProps, `properties.${breakpoint}.alignment`, {
    position: 'center',
    margin: 0
  });

  const verticalAlignment = _.get(widgetProps, `properties.${breakpoint}.verticalAlignment`, {
    position: 'center',
    margin: 0
  });

  var position = _.get(alignment, 'position', 'center');
  var margin = _.get(alignment, 'margin', 0);

  var verticalPosition = _.get(verticalAlignment, 'position', 'center');
  var verticalMargin = _.get(verticalAlignment, 'margin', 0);

  let containerStyles = {}

  //alignment
  containerStyles['justifyContent'] = position;

  if (position === 'left') {
    containerStyles = {
      ...containerStyles,
      justifyContent: 'flex-start',
      paddingLeft: `${margin}px`
    }
  } else if (position === 'right') {
    containerStyles = {
      ...containerStyles,
      justifyContent: 'flex-end',
      paddingRight: `${margin}px`
    }
  }

  //verticalAlignment
  containerStyles['alignItems'] = verticalPosition;

  if (verticalPosition === 'top') {
    containerStyles = {
      ...containerStyles,
      alignItems: 'flex-start',
      paddingTop: `${verticalMargin}px`
    }
  }
  else if (verticalPosition === 'bottom') {
    containerStyles = {
      ...containerStyles,
      alignItems: 'flex-end',
      paddingBottom: `${verticalMargin}px`
    }
  }

  return containerStyles;
}

const filterWidgetEquals = function (prevProps, nextProps) {
  const paths = ['className', 'style', 'widgetProps', 'breakpoint', 'children'];
  const next = _.pick(nextProps, paths);
  const previous = _.pick(prevProps, paths);

  const equals = _.isEqual(next, previous);
  return equals;
}

export const FilterWidget = React.memo(FilterWidgetComponent, filterWidgetEquals);

